import axios from "../../Axios/axiosConfig";

export class ProvisioningService {
    baseUrl;

    constructor(serverUrl) {
        this.baseUrl = serverUrl;
    }


    getCredentials = (controlUnitDmiSerialNumber) => {
        return axios.get(`${this.baseUrl}/api/v1/cu-registrations/${controlUnitDmiSerialNumber}/credentials`);
    }

}
